import makeHeaders from "./headers";

const BASE_API = process.env.REACT_APP_BASE_API_URI;

export const getAPI = async (model, params) => {
  const headers = await makeHeaders();
  let queryString = '';

  if (params) {
    params.forEach((param, index) => {
      if (index > 0) queryString += '&';
      const key = Object.keys(param)[0];
      queryString += key + '=' + param[key];
    });
  }

  try {
    const response = await fetch(`${BASE_API}/get${model}?${queryString}`, {
      headers: headers,
      method: 'GET',
    });
    
  
    if (response.ok) {
      const res = await response.json();
      return res;
    }
  } catch (error) {
    console.log('==Error getting api',error);
    throw new Error(error);
  }
};

export const callAPI = async (request) => {
  const headers = await makeHeaders();
  try {
    const response = await fetch(`${BASE_API}/${request}`, {
      headers: headers,
      method: 'GET',
    });
  
    if (response.ok) {
      const res = await response.json();
      if(res.Items) return res.Items
      return res;
    }
  } catch (error) {
    console.log('==Error getting api',error);
    throw new Error(error);
  }
};

export const postAPI = async (method, model, params) => {
  const headers = await makeHeaders();
  try {
    const response = await fetch(`${BASE_API}/${method}${model}`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify({ ...params }),
    });
    if (response.ok) {
      return response;
    }
  } catch (error) {
    console.log(error);
    throw new Error(error);
  }
};